import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import DeserveBox from '../components/deserveBox';
import { Accordion } from 'react-bootstrap';
import { DESERVER_STATUS_GROUPS, DESERVE_STATUS } from '../components/constants';
import { useTranslation } from "react-i18next";

const Deserves = () => {
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const [deserves, setDeserves] = useState([]);
  const [filteredDeserves, setFilteredDeserves] = useState([]);
  const [statusFilter, setStatusFilter] = useState(DESERVE_STATUS.OPEN); // Statusfilter für die Auswahl
  const { getAccessTokenSilently } = useAuth0();
  const { t } = useTranslation();

  const DESERVER_STATUS_DROPDOWN = React.useMemo(
    () =>
      Object.entries(DESERVER_STATUS_GROUPS).map(([groupKey, statusCodes]) => ({
        value: statusCodes[0],
        label: t(`deserve_status.${groupKey}`),
      })),
    [t] // re-run when language changes
  );

  useEffect(() => {
    async function getProducts() {
      const token = await getAccessTokenSilently();
      localStorage.setItem("AcccessToken", token);
      const response = await fetch(`${serverUrl}/api/deserves`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const deservesData = await response.json();
      setDeserves(deservesData);
      setFilteredDeserves(deservesData); // Setze anfänglich die gefilterten Daten auf alle Daten
    }
    getProducts();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (statusFilter === "all") {
      setFilteredDeserves(deserves);
    } else {
      // Find the group that contains the selected code
      const selectedGroup = Object.values(DESERVER_STATUS_GROUPS).find(group =>
        group.includes(Number(statusFilter))
      );

      if (selectedGroup) {
        setFilteredDeserves(
          deserves.filter(item => selectedGroup.includes(item.status))
        );
      } else {
        setFilteredDeserves([]); // no match
      }
    }
  }, [statusFilter, deserves]);

  const fb1 = "/img/fb1.png";
  const fb2 = "/img/fb2.png";
  const fbsp = "/img/fbsp.png";
  const ig1 = "/img/ig1.png";
  const x1 = "/img/x1.png";
  const x2 = "/img/x2.png";
  const lidt = "/img/lidt.png";
  const lisp = "/img/lisp.png";
  const tt1 = "/img/tt1.PNG";
  const tt2 = "/img/tt2.png";

  return (
    <div className="container">
      <h1>Meine deserves</h1>
      <p>
        Auf dieser Seite findest Du alle aktuell laufenden Angebote, an denen Du teilnimmst. Behalte den Überblick und verfolge den Status Deiner deserves!
      </p>
      <Accordion defaultActiveKey="1">
        <Accordion.Item eventKey="0" id="so-funktionierts">
          <Accordion.Header>So funktioniert's</Accordion.Header>
          <Accordion.Body>
            <strong>Dein Status – So läuft der Prozess ab</strong><br />
            Der <strong>Status</strong> zeigt Dir, in welchem Schritt des Prozesses Du Dich befindest. Du startest mit dem Sammeln von
            Likes und wirst Schritt für Schritt durch die Phasen geführt, bis Du Deine Belohnung erhältst.<br />

            <br /><strong>1 Offen: Teile & sammle Likes:</strong><br />
            • Teile Deinen deserve Post<br />
            • Sammle die benötigten Likes<br />
            • Stelle sicher, dass Dein Post öffentlich sichtbar ist und den Hashtag #mydeserve enthält<br />
            • Füge gerne einen persönlichen Text hinzu, um Deine Chancen auf Likes zu erhöhen<br />

            <br /><strong>Erfolg melden</strong><br />
            • Sobald Du genügend Likes gesammelt hast, klicke auf "Erfolg melden"<br />
            • Dabei wirst Du aufgefordert, den Link zu Deinem Post anzugeben<br />
            • Nach dem Eingeben des Links und der Bestätigung wechselt Dein Status automatisch auf <strong>deserved</strong><br />
            <br />Hier findest Du den Link zu deinem Post:
            {/* Unter-Akkordeon */}
            <Accordion>
              <Accordion.Item eventKey="00">
                <Accordion.Header>auf Facebook</Accordion.Header>
                <Accordion.Body>
                  {/* Unter-Akkordeon Instagram */}
                  <Accordion>
                    <Accordion.Item eventKey="000">
                      <Accordion.Header>am Smartphone</Accordion.Header>
                      <Accordion.Body>
                        <br />1.1 <img src={fbsp} style={{ maxWidth: '95%', height: 'auto' }} /><br />
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="001">
                      <Accordion.Header>am Desktop</Accordion.Header>
                      <Accordion.Body>
                        <br />1.1 <img src={fb1} style={{ maxWidth: '95%', height: 'auto' }} /><br />
                        <br />1.2 <img src={fb2} style={{ maxWidth: '95%', height: 'auto' }} /><br />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="01">
                <Accordion.Header>auf Instagram</Accordion.Header>
                <Accordion.Body>
                  <br />1.1 <img src={ig1} style={{ maxWidth: '95%', height: 'auto' }} /><br />
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="02">
                <Accordion.Header>auf X</Accordion.Header>
                <Accordion.Body>
                  <br />1.1 <img src={x1} style={{ maxWidth: '95%', height: 'auto' }} /><br />
                  <br />1.2 <img src={x2} style={{ maxWidth: '95%', height: 'auto' }} /><br />
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="03">
                <Accordion.Header>auf TikTok</Accordion.Header>
                <Accordion.Body>
                  <br />1.1 <img src={tt1} style={{ maxWidth: '95%', height: '500px' }} /><br />
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="04">
                <Accordion.Header>auf Linkedin</Accordion.Header>
                <Accordion.Body>
                  {/* Unter-Akkordeon Instagram */}
                  <Accordion>
                    <Accordion.Item eventKey="000">
                      <Accordion.Header>am Smartphone</Accordion.Header>
                      <Accordion.Body>
                        <br />1.1 <img src={lisp} style={{ maxWidth: '95%', height: 'auto' }} /><br />
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="001">
                      <Accordion.Header>am Desktop</Accordion.Header>
                      <Accordion.Body>
                        <br />1.1 <img src={lidt} style={{ maxWidth: '95%', height: 'auto' }} /><br />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <br /><strong>2 deserved: Dein deserve wird geprüft</strong><br />
            Wir prüfen Deine gesammelten Likes und setzen den Status anschließend auf <strong>Abgelehnt</strong> oder <strong>Akzeptiert</strong>.<br />

            <br /><strong>3 Abgelehnt / Akzeptiert: Prüfung & Weitergabe</strong><br />
            <strong>Akzeptiert:</strong> Dein deserve wurde erfolgreich geprüft! Wir teilen Deine Kontaktdaten mit dem Unternehmen. Anschliessend wirst Du kontaktiert und erhältst Deine Belohnung.<br />
            <strong>Abgelehnt:</strong> Dein deserve erfüllt leider nicht die Anforderungen. Falls Du Fragen hast, kannst Du uns gerne kontaktieren.<br />

            <br /><strong>Geniesse es!</strong><br />

            <br /><strong>4 Abgeschlossen: Dein deserve ist erfolgreich beendet</strong><br />
            Sobald Du Deine Belohnung erhalten hast, kannst Du den Prozess mit dem Button "Abschließen" beenden.<br />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>deserves</Accordion.Header>
          <Accordion.Body>
            {/* Statusauswahl */}
            <div className="form-group">
              <label htmlFor="statusFilter">Status filtern: </label>
              <select
                id="statusFilter"
                className="form-control"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="all">{t(`deserve_status.ALL`)}</option>
                {DESERVER_STATUS_DROPDOWN.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="row">
              {filteredDeserves.length > 0 ? (
                filteredDeserves.map((product) => (
                  <DeserveBox
                    key={product.idProduct}
                    product={product}
                    auth0AccessToken={localStorage.getItem("AcccessToken")}
                  />
                ))
              ) : (
                <p>Keine Produkte mit diesem Status gefunden.</p>
              )}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default Deserves;